import "./announce-errors";
import "./session-expiry";
import toggleMarkdown from "./editor/index";
import initMentions, { insertMetric } from "./editor/mentions";
import headlessTippy from "tippy.js/headless";
import Billing from "./alpine/billing";
import Tabs from "./alpine/tabs";
import ScorecardCellsTheme from "./alpine/scorecard-cells-theme-v2";
import ScorecardCellsDelta from "./alpine/scorecard-cells-delta";
import ScorecardRowsSectionsDeletion from "./alpine/scorecard-rows-sections-deletion.js";
import ScorecardColumnHighlight from "./alpine/scorecard-column-highlight";
import ScorecardScrollSync from "./alpine/scorecard-scroll-sync";
import ScorecardColumnResize from "./alpine/scorecard-column-resize";
import ScorecardInsertZones from "./alpine/scorecard-insert-zones";
import ScorecardCustomizeOperations from "./alpine/scorecard-customize-operations";
import ScorecardHeaderGenerator from "./alpine/scorecard-header-generator";
import DrilldownTable from "./alpine/drilldown.js";
import DrilldownBlinkTable from "./alpine/drilldown-blink-table.js";
import SupersetChart from "./alpine/superset-chart.js";
import SupersetTable from "./alpine/superset-table.js";
import DateFilter from "./alpine/date-filter.js";
import SelectFilter from "./alpine/select-filter.js";
import ChoiceFilter from "./alpine/choice-filter.js";
import MonthFilter from "./alpine/month-filter.js";
import ScorecardCellOverlays from "./alpine/scorecard-cell-overlays";
import ScorecardMetricAggregationValidator from "./alpine/scorecard-metric-aggregation-validator";
import ScorecardTabsControl from "./alpine/scorecard-tabs-control";
import ScorecardTruncationTooltip from "./alpine/scorecard-truncation-tooltip";
import ScorecardMetricDetailsDrawer from "./alpine/scorecard-metric-details-drawer";
import MetricScreenChart from "./alpine/metric-screen-chart";
import SiteAnalyticsReport from "./alpine/site-analytics-report";
import SiteAnalyticsExplore from "./alpine/site-analytics-explore";
import SiteAnalyticsArrange from "./alpine/site-analytics-arrange";
import SiteAnalyticsTopics from "./alpine/site-analytics-topics";
import SortableRows from "./alpine/sortable-rows";
import InsightsActivityTable from "./alpine/insights-activity-table";
import InsightsActivitySummary from "./alpine/insights/activity-summary.js";
import ReportPage from "./alpine/report-page";
import ReportGridGaps from "./alpine/report-grid-gaps";
import ReportFilterBar from "./filters/report-filter-bar";
import SiteAnalyticsEditMode from "./alpine/site-analytics-edit";
import SiteAnalyticsFilterHeader from "./filters/site-analytics-filter-header";
import InsightsViews from "./alpine/insights-views";
import InsightsActions from "./alpine/insights-actions";
import InsightsTopBar from "./alpine/insights-top-bar";
import InsightsSortSearches from "./alpine/insights-sort-searches";
import InsightsSortTiles from "./alpine/insights-sort-tiles";
import InsightsSetupSortBoard from "./alpine/insights-setup-sort-board";
import AccessibilityImpactDonut from "./alpine/accessibility-impact-donut";
import { moveRows } from "./alpine/view-transition";
import InsightsToast from "./alpine/insights/toast.js";
import InsightsTooltip from "./alpine/insights/tooltip.js";
import InsightsWhyItRanks from "./alpine/insights/why-it-ranks.js";
import InsightsDropdown from "./alpine/insights/dropdown.js";
import InsightsGoal from "./alpine/insights/goal.js";
import { CountUpDirective, StaggerDirective } from "./alpine/insights/motion.js";
import { FigureDirective } from "./alpine/insights/figure-motion.js";
import { ListMotionDirective } from "./alpine/insights/list-motion.js";
import { connectInsights } from "./alpine/insights-connect";
import InsightsTopicTrendChart from "./alpine/insights/topic-trend-chart.js";
import AccessibilityIssuesOverTime from "./alpine/accessibility-issues-over-time.js";
import RegroupStore, { STORE as REGROUP_STORE } from "./alpine/insights/regroup.js";
import HiddenPagesStore, { STORE as HIDDEN_PAGES_STORE } from "./alpine/insights/hidden-pages.js";
import { press as pressInsightsWrite, relay as relayInsightsWrites, send as sendInsightsWrite } from "./alpine/insights/writes.js";
import InsightsOutOfDate from "./alpine/insights/out-of-date.js";
import InsightsTopicFind from "./alpine/insights/topic-find.js";
import InsightsGuides from "./alpine/insights/guides.js";
import { closeAfterCopy, watch as watchTargetFlights } from "./alpine/insights/target-flight.js";
import SearchSelect from "./alpine/search-select";
import Select2 from "./alpine/select2";
import Select2Server from "./alpine/select2-server";
import SelectMultiServer from "./alpine/select-multi-server";
import listKeyboardNav, { byLayout as listKeyboardNavByLayout } from "./alpine/list-keyboard-nav";
import QuickSearch from "./alpine/quick-search";
import { matchesChord, isMacPlatform } from "./alpine/chord";
import ToastManager from "./alpine/toast-manager";
import VirtualScrollDirective from "./alpine/virtual-scroll-directive";
import FitRowsDirective from "./alpine/fit-rows-directive";
import RowWindowDirective from "./alpine/row-window-directive";
import FilterReachDirective from "./alpine/filter-reach-directive";
import hoverintent from 'hoverintent';
import { flare } from "@flareapp/js";
import SyncManualData from "./alpine/sync-manual-data-v2";
import Steps from "./alpine/steps";
import { forceNextTick } from "./alpine/forceNextTick.js";
import { focusInView } from "./alpine/focus-in-view";
import { debounce, throttle, trapFocus, castToBoolean, relativeFromIso } from "./utils"
import sort from '@alpinejs/sort';
import $ from 'jquery';
import moment from "moment";
import DateRangePicker from "./vanilla-datetimerange-picker/vanilla-datetimerange-picker.js";
window.$ = window.jQuery = $;

// Import Select2 pillbox after jQuery and before Alpine
import select2 from 'select2';
select2($);

import 'select2/dist/css/select2.min.css';

document.addEventListener("DOMContentLoaded", function () {
    // Only enable Flare in beta & production, we don't want to waste your quota while you're developing:
    if (window.blinkmetrics_env?.APP_ENV && ['production', 'beta'].includes(window.blinkmetrics_env.APP_ENV)) {
        flare.light(window.blinkmetrics_env.FLARE_JS_PUBLIC_KEY);
        flare.addContext('user information', {
            user: {
                id: window.blinkmetrics_env.USER_ID,
                workspace_id: window.blinkmetrics_env.WORKSPACE_ID,
                email: window.blinkmetrics_env.EMAIL
            }
        });
    }
});

document.addEventListener('alpine:init', () => {
    Alpine.data("Billing", Billing);
    Alpine.data("Drilldown", DrilldownTable);
    Alpine.data("DrilldownBlinkTable", DrilldownBlinkTable);
    Alpine.data("SupersetChart", SupersetChart);
    Alpine.data("SupersetTable", SupersetTable);
    Alpine.data("DateFilter", DateFilter);
    Alpine.data("SelectFilter", SelectFilter);
    Alpine.data("ChoiceFilter", ChoiceFilter);
    Alpine.data("MonthFilter", MonthFilter);
    Alpine.data("SearchSelect", SearchSelect);
    Alpine.data("select2", Select2);

    Alpine.data("select2Server", Select2Server);
    Alpine.data("selectMultiServer", SelectMultiServer);
    Alpine.data("Tabs", Tabs);
    Alpine.data("ScorecardCellsTheme", ScorecardCellsTheme);
    Alpine.data("ScorecardCellsDelta", ScorecardCellsDelta);
    Alpine.data("ScorecardRowsSectionsDeletion", ScorecardRowsSectionsDeletion);
    Alpine.data("ScorecardColumnHighlight", ScorecardColumnHighlight);
    Alpine.data("ScorecardScrollSync", ScorecardScrollSync);
    Alpine.data("ScorecardColumnResize", ScorecardColumnResize);
    Alpine.data("ScorecardInsertZones", ScorecardInsertZones);
    Alpine.data("ScorecardCustomizeOperations", ScorecardCustomizeOperations);
    Alpine.data("ScorecardHeaderGenerator", ScorecardHeaderGenerator);
    Alpine.data("ScorecardCellOverlays", ScorecardCellOverlays);
    Alpine.data("ScorecardMetricAggregationValidator", ScorecardMetricAggregationValidator);
    Alpine.data("ScorecardTabsControl", ScorecardTabsControl);
    Alpine.data("ScorecardTruncationTooltip", ScorecardTruncationTooltip);
    Alpine.data("ScorecardMetricDetailsDrawer", ScorecardMetricDetailsDrawer);
    Alpine.data("MetricScreenChart", MetricScreenChart);
    Alpine.data("SiteAnalyticsReport", SiteAnalyticsReport);
    Alpine.data("SiteAnalyticsExplore", SiteAnalyticsExplore);
    Alpine.data("SiteAnalyticsArrange", SiteAnalyticsArrange);
    Alpine.data("SiteAnalyticsTopics", SiteAnalyticsTopics);
    Alpine.data("SortableRows", SortableRows);
    Alpine.data("InsightsActivityTable", InsightsActivityTable);
    // The Guides view (D181): the hub's search and its answers, the guides' sections and the calculators (insights/guides.js).
    Alpine.data("InsightsGuides", InsightsGuides);
    // An activity's summary panel, worked out again as its table's rows change (insights/activity-summary.js).
    Alpine.data("InsightsActivitySummary", InsightsActivitySummary);
    Alpine.data("ReportPage", ReportPage);
    Alpine.data("ReportGridGaps", ReportGridGaps);
    Alpine.data("ReportFilterBar", ReportFilterBar);
    Alpine.data("SiteAnalyticsEditMode", SiteAnalyticsEditMode);
    Alpine.data("SiteAnalyticsFilterHeader", SiteAnalyticsFilterHeader);
    Alpine.data("InsightsViews", InsightsViews);
    Alpine.data("InsightsActions", InsightsActions);
    Alpine.data("InsightsTopBar", InsightsTopBar);
    Alpine.data("InsightsSortSearches", InsightsSortSearches);
    Alpine.data("InsightsSortTiles", InsightsSortTiles);
    Alpine.data("InsightsSetupSortBoard", InsightsSetupSortBoard);
    // A site's Accessibility tab: the issues-by-impact donut's wedges and middle as legend pills hide severities.
    Alpine.data("AccessibilityImpactDonut", AccessibilityImpactDonut);
    // $moveRows(update): a list marked x-list-motion re-ranked or thinned as one view transition (alpine/view-transition.js).
    Alpine.magic("moveRows", () => moveRows);
    // The v3 shared parts (components/insights/) and their motion helpers (D67, D74).
    Alpine.data("InsightsToast", InsightsToast);
    Alpine.data("InsightsTooltip", InsightsTooltip);
    // Why it ranks, in clicks (P23, D126), for a list the server draws: Search ideas and Your top 5.
    Alpine.data("InsightsWhyItRanks", InsightsWhyItRanks);
    // One choice from a short list, in the Insights dropdown style (Ola's QA, 9 Oct).
    Alpine.data("InsightsDropdown", InsightsDropdown);
    // Stage 8's Alpine seat (D94), empty until filled: S55's goal dialog.
    Alpine.data("InsightsGoal", InsightsGoal);
    Alpine.directive("count-up", CountUpDirective);
    Alpine.directive("stagger", StaggerDirective);
    // A picker card's figure: still as painted, moving only when it arrives or changes later.
    Alpine.directive("figure", FigureDirective);
    Alpine.directive("list-motion", ListMotionDirective);
    // $connectInsights(siteId, sourceId): Connect insights, told where it was opened from (S33, D78).
    Alpine.magic("connectInsights", (el) => connectInsights(el));
    // Check my results' topics over time, the first chart the app draws on Insights (S40).
    Alpine.data("InsightsTopicTrendChart", InsightsTopicTrendChart);
    // The Accessibility tab's issues-over-time card: its Chart / Table switch and legend (#26).
    Alpine.data("AccessibilityIssuesOverTime", AccessibilityIssuesOverTime);
    // Regroup AI topics' state, which its button, the line under it and its panel read (S44).
    Alpine.store(REGROUP_STORE, RegroupStore());
    // A hidden clicks figure's press and its tooltip's top pages, read once per screen (P90, insights/hidden-pages.js).
    Alpine.store(HIDDEN_PAGES_STORE, HiddenPagesStore());
    // The simplification stack's two browser seats (P1 of insights-simplify-plan.md, section 7): every row
    // and topic write goes through $insightsWrite({action, payload, livewire}) (insights/writes.js), and every
    // other open screen shows its out-of-date mark (insights/out-of-date.js).
    // A press marks its button busy until the write answers, and ignores a second press meanwhile (writes.js press()).
    Alpine.magic("insightsWrite", (el) => (write) => pressInsightsWrite(el, write));
    // The same write for a press that already shows its own answer (Copy prompt's Copied), so it is never dimmed as busy.
    Alpine.magic("insightsSend", () => (write) => sendInsightsWrite(write));
    Alpine.data("InsightsOutOfDate", InsightsOutOfDate);
    // Find a topic in Move to topic, for a list the server draws: Sort my searches' dialog and Search ideas' ⋯ (D172).
    Alpine.data("InsightsTopicFind", InsightsTopicFind);
    relayInsightsWrites();
    // A copied prompt's drawer closes once its row has folded, then its search flies from that row into the top
    // bar's Target keywords button, which pulses once (P83, D189); the toast's Undo stops it.
    Alpine.magic("closeAfterCopy", () => closeAfterCopy);
    watchTargetFlights();
    Alpine.data("SyncManualData", SyncManualData);
    Alpine.data("Steps", Steps);
    Alpine.data("ToastManager", ToastManager);
    Alpine.data("quickSearch", QuickSearch);
    Alpine.directive("virtual-scroll", VirtualScrollDirective);
    Alpine.directive("fit-rows", FitRowsDirective);
    // An opened topic's list of searches: ten rows high, the rest scrolling (Ola's QA, 9 Oct).
    Alpine.directive("row-window", RowWindowDirective);
    Alpine.directive("filter-reach", FilterReachDirective);
    Alpine.plugin(sort)
    Alpine.magic('forceNextTick', () => forceNextTick);
    // $focusInView(el) — focus that also clears a pinned edit bar or filter header (alpine/focus-in-view.js).
    Alpine.magic('focusInView', () => focusInView);

    // $chord($event, {code: 'KeyO', shift: true}) — the shared Cmd/Ctrl chord matcher, so the
    // three components that own a shortcut state the chord and nothing else. See alpine/chord.js.
    Alpine.magic('chord', () => (event, chord) => matchesChord(event, chord));
    Alpine.magic('isMac', () => isMacPlatform());

    // $clipboard(text) — works in insecure contexts (e.g. http://blinkmetrics.tech)
    // where navigator.clipboard is undefined. Falls back to a hidden-span + execCommand.
    Alpine.magic('clipboard', () => subject => {
        if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText(subject)
            return
        }
        const span = document.createElement('span')
        span.textContent = subject
        span.style.cssText = 'position:fixed;top:0;left:0;opacity:0;white-space:pre;user-select:text;'
        document.body.appendChild(span)
        const range = document.createRange()
        range.selectNodeContents(span)
        const sel = window.getSelection()
        if (!sel) {
            document.body.removeChild(span)
            return
        }
        sel.removeAllRanges()
        sel.addRange(range)
        document.execCommand('copy')
        sel.removeAllRanges()
        document.body.removeChild(span)
    });

    Alpine.store('toastStore', ToastManager());
})

window.debounce = debounce;
window.throttle = throttle;
window.trapFocus = trapFocus;
window.listKeyboardNav = listKeyboardNav;
window.listKeyboardNav.byLayout = listKeyboardNavByLayout;
window.castToBoolean = castToBoolean;
window.relativeFromIso = relativeFromIso;
window.toggleMarkdown = toggleMarkdown;
window.initMentions = initMentions;
window.insertMetric = insertMetric;
window.hoverintent = hoverintent;
window.moment = moment;
window.DateRangePicker = DateRangePicker;

window.tippy = function (selector, tooltip) {
    if (!tooltip.length) {
        return;
    }
    headlessTippy(selector, {
        content: tooltip,
        placement: "right",
        arrow: true,
        render(instance) {
            const popper = document.createElement("div");
            popper.className = "p-2 tippy-box";

            const box = document.createElement("div");
            box.className = "max-w-sm p-2 bg-white rounded shadow";
            box.textContent = instance.props.content;

            const icon = document.createElement("div");

            popper.appendChild(box);

            function onUpdate(prevProps, nextProps) {
                if (prevProps.content !== nextProps.content) {
                    box.textContent = nextProps.content;
                }
            }

            return {
                popper,
                onUpdate, // optional
            };
        },
    });
};
